import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { Phone, Mail, MapPin, Send, CheckCircle2 } from 'lucide-react';
import { siteConfig } from '../data/mock';
import { useScrollReveal } from '../hooks/useScrollAnimation';

const Contact = () => {
//   const [form, setForm] = useState({ name: '', email: '', phone: '', company: '', message: '' });
//   const [submitted, setSubmitted] = useState(false);
//   const [loading, setLoading] = useState(false);
const [form, setForm] = useState({
  name: '',
  email: '',
  phone: '',
  company: '',
  message: ''
});

const [errors, setErrors] = useState({});
const [submitted, setSubmitted] = useState(false);
const [loading, setLoading] = useState(false);

  const [focusedField, setFocusedField] = useState(null);

  const [formRef, formVisible] = useScrollReveal({ threshold: 0.1 });

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setTimeout(() => { setLoading(false); setSubmitted(true); }, 1200);
  // };

  const validate = () => {
  const newErrors = {};

  // Required fields
  if (!form.name.trim()) newErrors.name = "Full name is required";
  if (!form.company.trim()) newErrors.company = "Company name is required";
  if (!form.phone.trim()) newErrors.phone = "Phone number is required";
  if (!form.message.trim()) newErrors.message = "Message is required";

  // Email validation
  if (!form.email.trim()) {
    newErrors.email = "Business email is required";
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const blockedDomains = [
      "gmail.com","yahoo.com","hotmail.com","outlook.com",
      "live.com","icloud.com","aol.com","protonmail.com",
      "zoho.com","yandex.com","gmx.com","mail.com"
    ];

    const domain = form.email.split("@")[1]?.toLowerCase();

    if (!emailRegex.test(form.email)) {
      newErrors.email = "Enter a valid email address";
    } else if (blockedDomains.includes(domain)) {
      newErrors.email = "Please use your company email address";
    }
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  setLoading(true);

  const formPayload = new FormData();
  formPayload.append("name", form.name);
  formPayload.append("email", form.email);
  formPayload.append("phone", form.phone);
  formPayload.append("company", form.company);
  formPayload.append("message", form.message);

  try {
    await fetch("https://b2btechleads.com/b2b-lead/send-mail.php", {
      method: "POST",
      body: formPayload,
    });

    setSubmitted(true);
    setForm({
      name: '',
      email: '',
      phone: '',
      company: '',
      message: ''
    });
    setErrors({});
  } catch (err) {
    console.error("Send failed", err);
  }

  setLoading(false);
};

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (!validate()) return;

//   setIsSubmitting(true);
//   setIsSubmitted(true);

//   const formPayload = new FormData();
//   formPayload.append("name", formData.name);
//   formPayload.append("email", formData.email);
//   formPayload.append("phone", formData.phone);
//   formPayload.append("company", formData.company);
//   formPayload.append("message", formData.message);

//   fetch("https://b2btechleads.com/b2b-lead/send-mail.php", {
//     method: "POST",
//     body: formPayload,
//   }).catch(err => console.error("Background send failed", err));

//   setFormData({
//     name: "",
//     email: "",
//     company: "",
//     // countryCode: "+1",
//     countryCode: "",
//     phone: "",
//     message: "",
//     optIn: false,
//   });

//   setErrors({});
//   setIsSubmitting(false);
// };
  const inputClass = (name) =>
    `w-full border px-4 py-3 text-sm rounded-xl focus:outline-none bg-white ${
      focusedField === name
        ? 'border-[#43a047] ring-2 ring-[#43a047]/20'
        : 'border-border hover:border-border'
    }`;

  const contactInfo = [
    { icon: Phone, label: 'Phone', value: siteConfig.phone, href: `tel:${siteConfig.phone}` },
    { icon: Mail,  label: 'Email', value: siteConfig.email, href: `mailto:${siteConfig.email}` },
    { icon: MapPin, label: 'Address', value: siteConfig.address, href: null },
  ];

  return (
    <div className="page-enter">
      <PageHeader title="Contact Us" breadcrumbs={[{ label: 'Contact' }]} />

      <div className="py-16 bg-background">
        <div className="max-w-6xl mx-auto px-4">

          {/* Heading */}
          <div className="text-center mb-12">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: '#43a047' }}>Get In Touch</p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground mb-3">
              We'd Love to Hear From You
            </h2>
            <div className="w-14 h-1 mx-auto rounded-full mb-4" style={{ background: '#43a047' }} />
            <p className="text-muted-foreground text-sm max-w-lg mx-auto">
              Fill in the form with your requirements and we'll get back to you within 24 hours.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-10">

            {/* ── Form ── */}
            <div className="flex-1" ref={formRef}>
              {submitted ? (
                <div className="anim-scale-in flex flex-col items-center justify-center py-20 text-center bg-muted rounded-2xl border border-border">
                  <div
                    className="w-20 h-20 rounded-full flex items-center justify-center mb-5 shadow-lg"
                    style={{ backgroundColor: '#43a047' }}
                  >
                    <CheckCircle2 size={36} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-extrabold text-foreground mb-2">Thank You!</h3>
                  <p className="text-muted-foreground text-sm max-w-sm mb-6">
                    We've received your message. Our team will get back to you within 24 hours.
                  </p>
                  <button
                    onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', company: '', message: '' }); }}
                    className="text-white text-sm font-semibold px-7 py-3 rounded-full"
                    style={{ backgroundColor: '#43a047', transition: 'opacity 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  className={`space-y-4 ${formVisible ? 'anim-slide-right' : 'reveal-hidden'}`}
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {[
                     { name: 'name', label: 'Full Name', type: 'text', required: true },
  { name: 'email', label: 'Email Address', type: 'email', required: true },
  { name: 'phone', label: 'Phone Number', type: 'tel', required: true },
  { name: 'company', label: 'Company Name', type: 'text', required: true },
                    ].map((field) => (
                      <div key={field.name}>
                        <label className="block text-sm font-semibold text-foreground mb-1.5">
                          {field.label} {field.required && <span style={{ color: '#43a047' }}>*</span>}
                        </label>
                        <input
                          type={field.type}
                          name={field.name}
                          value={form[field.name]}
                          onChange={handleChange}
                          required={field.required}
                          placeholder={field.placeholder}
                          onFocus={() => setFocusedField(field.name)}
                          onBlur={() => setFocusedField(null)}
                          className={inputClass(field.name)}
                          style={{ transition: 'border-color 0.2s, box-shadow 0.2s' }}
                        />
                        {errors.name && (
  <p className="text-red-500 text-xs mt-1">{errors.name}</p>
)}
                      </div>
                    ))}
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-foreground mb-1.5">
                      Message <span style={{ color: '#43a047' }}>*</span>
                    </label>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      required
                      rows={5}
                      placeholder="Tell us about your requirements..."
                      onFocus={() => setFocusedField('message')}
                      onBlur={() => setFocusedField(null)}
                      className={inputClass('message')}
                      style={{ resize: 'none', transition: 'border-color 0.2s, box-shadow 0.2s' }}
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn-pulse inline-flex items-center gap-2 text-white font-semibold px-8 py-3 rounded-full shadow-md text-sm disabled:opacity-60"
                    style={{ backgroundColor: '#43a047', transition: 'opacity 0.2s, transform 0.2s' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
                  >
                    {loading ? (
                      <span className="flex items-center gap-2">
                        <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin inline-block" />
                        Sending...
                      </span>
                    ) : (
                      <><Send size={14} /> Send Message</>
                    )}
                  </button>
                </form>
              )}
            </div>

            {/* ── Contact Info ── */}
            <div className="lg:w-80 space-y-5">
              {/* Info card */}
              <div
                className={`rounded-2xl overflow-hidden border border-border ${formVisible ? 'anim-slide-left' : 'reveal-hidden'}`}
              >
                <div className="px-6 py-4" style={{ borderBottom: '3px solid #43a047', background: '#fafafa' }}>
                  <h3 className="font-bold text-foreground">Contact Information</h3>
                </div>
                <div className="p-6 space-y-5">
                  {contactInfo.map(({ icon: Icon, label, value, href }, i) => (
                    <div
                      key={i}
                      className={`flex items-start gap-4 ${formVisible ? 'anim-fade-up' : 'reveal-hidden'}`}
                      style={{ animationDelay: `${0.2 + i * 0.1}s` }}
                    >
                      <div
                        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                        style={{ backgroundColor: '#43a047' }}
                      >
                        <Icon size={16} className="text-white" />
                      </div>
                      <div>
                        <p className="text-xs text-muted-foreground mb-0.5 font-medium">{label}</p>
                        {href ? (
                          <a href={href} className="text-sm font-medium text-foreground hover:text-[#43a047]" style={{ transition: 'color 0.2s' }}>
                            {value}
                          </a>
                        ) : (
                          <p className="text-sm font-medium text-foreground">{value}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Response time */}
              <div
                className={`rounded-2xl p-5 text-white relative overflow-hidden ${formVisible ? 'anim-fade-up delay-400' : 'reveal-hidden'}`}
                style={{ backgroundColor: '#43a047' }}
              >
                <div className="absolute -top-6 -right-6 w-20 h-20 rounded-full bg-white/10" />
                <h4 className="font-bold mb-1 text-sm relative">Fast Response Time</h4>
                <p className="text-xs text-green-100 leading-relaxed relative">
                  We respond to all inquiries within <strong className="text-white">24 hours</strong>. For urgent matters, call us directly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
